module.exports = __webpack_public_path__ + "img/img.1ced612b.png";